export default "__VITE_ASSET__C08kBmU___"